import React from "react";
import FooterPagination from "../../Pagination/FooterPagination";
import { Table } from "reactstrap";
import { capitalizeFirstLetter, formatDate } from "../../../utils/utils";

const CronJobsTable = ({ data, paginationProps }) => {
  const renderBadgeStatus = (status) => {
    let color =
      status === "start"
        ? "soft-primary text-muted"
        : "end"
        ? "success"
        : "danger";
    return (
      <span className={`badge rounded-pill bg-${color} font-size-12`}>
        {capitalizeFirstLetter(status)}
      </span>
    );
  };

  return (
    <Table className="table table-hover border table-centered align-middle table-nowrap mb-0">
      <thead className="bg" style={{ background: "var(--thead-bg)" }}>
        <tr>
          <th scope="col" className="text-start">
            Name
          </th>
          <th scope="col" style={{ width: "250px" }} className="text-center">
            Type
          </th>
          <th scope="col" className="text-center">
            Executed At
          </th>
        </tr>
      </thead>
      <tbody>
        {data.length === 0 ? (
          <tr>
            <td className="text-center" colSpan="5">
              No data found
            </td>
          </tr>
        ) : (
          data.map((jobs, index) => (
            <tr key={index}>
              <td>{jobs.jobName}</td>
              <td className="text-center">
                {renderBadgeStatus(jobs.eventType)}
              </td>
              <td className="text-center">{formatDate(jobs.executedAt)}</td>
            </tr>
          ))
        )}
      </tbody>
      {paginationProps.totalItems > 0 && (
        <tfoot>
          <FooterPagination {...paginationProps} />
        </tfoot>
      )}
    </Table>
  );
};

export default CronJobsTable;
